/**
 * Feed sort/display timestamps for mail-backed events. The DB `created_at` is
 * the ingest/emit time; operators expect rows to show when the email arrived.
 */
import type { FeedEvent } from "@/types/feed";
import { isGraphMailPayload } from "./GraphMailFeedDetail";
import { isNewBookingMailPayload } from "./NewBookingMailFeedDetail";

/** Actual mail received time when known, else the feed insert time. */
export function feedEventDisplayIso(event: FeedEvent): string {
  const payload = event.payload;
  if (isGraphMailPayload(payload) || isNewBookingMailPayload(payload)) {
    if (payload.received_at) return payload.received_at;
  }
  return event.created_at;
}

/** Milliseconds since epoch for sorting and live-merge comparisons. */
export function feedEventDisplayTimestamp(event: FeedEvent): number {
  const parsed = Date.parse(feedEventDisplayIso(event));
  return Number.isNaN(parsed) ? 0 : parsed;
}
